import { useTranslation } from 'react-i18next';
import TimeAgo from 'react-timeago';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

import { StyleProps, Text, TextProps, Tooltip } from '@bonusly/design-system';

import { DateSource } from '../../../types/date';
import { toDateObject } from '../../../utils/date';
import { enShort } from './locales';

const formatter = buildFormatter(enShort);

interface Props extends StyleProps, TextProps {
	date: DateSource;
	now?: () => number;
}

const RelativeTime: React.FC<Props> = ({ date, now, ...rest }: Props) => {
	const { t } = useTranslation('common');

	const label = t('intl_datetime', {
		value: toDateObject(date),
		formatParams: {
			value: {
				day: 'numeric',
				hour12: true,
				hour: 'numeric',
				minute: 'numeric',
				month: 'long',
				year: 'numeric',
			},
		},
	});

	return (
		<Tooltip label={label}>
			<Text as="span" {...rest}>
				<TimeAgo aria-label={label} date={date} formatter={formatter} now={now} role="timer" title="" />
			</Text>
		</Tooltip>
	);
};

export default RelativeTime;
